import { Component, ElementRef, Input, OnInit, ViewChild } from '@angular/core';

@Component({
	selector: 'app-ice-machine-benefits',
	templateUrl: './ice-machine-benefits.component.html',
	styleUrls: ['./ice-machine-benefits.component.scss'],
})
export class IceMachineBenefitsComponent implements OnInit {
	@Input() data: any = {}
	@ViewChild('scrollContainer', { static: true }) scrollContainer!: ElementRef<HTMLDivElement>

	constructor() { }

	ngOnInit(): void { }

	scrollPrev() {
		this.scrollByCard(-1)
	}

	scrollNext() {
		this.scrollByCard(1)
	}

	private scrollByCard(direction: number) {
		const container = this.scrollContainer.nativeElement
		const card = container.querySelector<HTMLElement>('.slide')
		const step = card ? card.offsetWidth + 20 : container.clientWidth * 0.8
		container.scrollBy({ left: direction * step, behavior: 'smooth' })
	}
}
